import WidePrimaryButton from './WidePrimaryButton';
export default WidePrimaryButton;